interface CustomWindow extends Window {
  SERVER_YEAR: number;
}
declare let window: CustomWindow;

export const searchConstants = <const>{
  sorts: {
    relevance: {
      labelId: 'app.pages.search.sort.relevance',
      event: 'sort_relevance',
    },
    chrono: {
      labelId: 'app.pages.search.sort.chrono',
      event: 'sort_chrono',
    },
    antiChrono: {
      labelId: 'app.pages.search.sort.antiChrono',
      event: 'sort_chrono_inverted',
    },
    commented: {
      labelId: 'app.pages.search.sort.commented',
      event: 'sort_commented',
    },
  },
  types: [
    {
      key: 'arret',
      labelId: 'app.pages.search.labelType.decision',
    },
    {
      key: 'commentary',
      labelId: 'app.pages.search.labelType.commentary',
    },
    {
      key: 'law',
      labelId: 'app.pages.search.labelType.legislation',
    },
    { key: 'lawyer', labelId: 'app.pages.search.labelType.lawyer' },
    {
      key: 'enterprise',
      labelId: 'app.pages.search.labelType.enterprise',
    },
  ],

  filters: {
    juridiction: 'app.pages.search.facets.juridiction',
    dates: 'app.pages.search.facets.dates',
    inForceDates: 'app.pages.search.facets.inForceDates',
    solution: 'app.pages.search.facets.solution',
    domaine: 'app.pages.search.facets.domaine',
    ville: 'app.pages.search.facets.ville',
    publi: 'app.pages.search.facets.publi',
    parties: 'app.pages.search.facets.parties',
    exclude: 'app.pages.search.facets.exclude',
    publisher: 'app.pages.search.facets.publisher',
    textCode: 'app.pages.search.facets.textCode',
    collectiveAgreements: 'app.pages.search.facets.collectiveAgreements',
    otherLegislation: 'app.pages.search.facets.otherLegislation',
  },
  years: {
    yearNow: window.SERVER_YEAR,
    yearNowMinusOne: window.SERVER_YEAR - 1,
    yearNowMinusFour: window.SERVER_YEAR - 4,
  },
};
